import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=e94dccf4&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"
import style0 from "./Join.vue?vue&type=style&index=0&id=e94dccf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94dccf4",
  null
  
)

export default component.exports